import { motion, useReducedMotion } from 'framer-motion';

const EASE = [0.16, 1, 0.3, 1];

// One-time gentle reveal used across scenes.
export const Reveal = ({ children, className = '', delay = 0, y = 28 }) => {
  const reduced = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduced ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: reduced ? 0 : 1, delay: reduced ? 0 : delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
};

// The recurring single thin line (accent). Draws in on view.
export const ThinLine = ({ className = '', width = '100%', delay = 0 }) => {
  const reduced = useReducedMotion();
  return (
    <motion.div
      className={`dh-hairline ${className}`}
      style={{ width }}
      initial={reduced ? false : { scaleX: 0 }}
      whileInView={{ scaleX: 1 }}
      viewport={{ once: true, amount: 0.6 }}
      transition={{ duration: reduced ? 0 : 1.1, delay, ease: EASE }}
    />
  );
};

// Small numbered chapter label.
export const SceneLabel = ({ index, children }) => (
  <div className="flex items-center gap-4">
    <span className="dh-kicker">{index}</span>
    <span className="dh-eyebrow">{children}</span>
  </div>
);

export { EASE };
